/**
 * H8 (dashboard spec §6, card A4): Esc for a modal screen opened over the pause menu (the away report, the Registrant).
 * While paused the loop never offers Esc to `ui.escape` (pausing again is a no-op) and the menu's capture-phase key
 * listener would swallow it, so a screen that only registered an `enterModal` Esc handler could not be closed with
 * Esc. The menu's key listener calls this first: while a screen covers the menu, Esc goes to the top modal's handler.
 */
import type { UiState } from '../../app/feature'
import { consumeEscape } from '../../app/ui'
import { menuCovered } from '../../hud/menu'

/** True when the press was a fresh Esc, the menu is open, a screen covers it and that screen's handler consumed it. */
export function routeCoverEscape(ui: UiState, code: string, repeat: boolean, menuOpen: boolean): boolean {
  if (!menuOpen || repeat || code !== 'Escape' || !menuCovered()) return false
  return consumeEscape(ui)
}
